// NOTE: key 'COUNTRY_LIST' is used by many useSelector hooks throughout the app

import registerCountryRedux from 'app/resources/country';
import { useSelector } from 'react-redux';

const key = 'COUNTRY_LIST';

export const countryListRedux = registerCountryRedux(key, ['LIST']);

export const useCountryList = () => useSelector((state) => state[key]);
